<template>
  <div class="videoPlay inner">
    <!-- 视频播放页 -->
    <div class="top">
      <div class="left">
        <video :src="adddom(videodetail.video.video_file)" width="100%" height="100%" controls autoplay></video>
        <!-- <video width="100%" height="100%" controls="controls" autoplay="autoplay">
          <source :src="adddom(videodetail.video.video_file)" type="video/ogg" />
          <source :src="adddom(videodetail.video.video_file)" type="video/mp4" />
          您的浏览器不支持 HTML5 video 标签。
        </video> -->
      </div>
      <div class="right">
        <div
          class="video_item"
          v-for="(item,index) in videodetail.recom"
          :key="index"
          @click="toPlay(item.video_id)"
        >
          <div class="pic">
            <img :src="adddom(item.thumb_image)" alt />
          </div>
          <div class="name">
            <span>{{item.title}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 标题 -->
    <div class="bottom">
      <div class="title">
        <span>{{videodetail.video.title}}</span>
      </div>
      <div class="desc">
        <span>{{videodetail.video.count}}次播放量</span>
        <span>发布时间{{videodetail.video.publish_at}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoId: "", //视频id
      videodetail: {
        recom: [],
        video: {}
      }
    };
  },
  created() {
    this.videoId = this.$route.query.id;
    this.getVideoInfo();
     function mobileskip() {
      var mobileAgent = new Array(
        "iphone",
        "ipod",
        "ipad",
        "android",
        "mobile",
        "blackberry",
        "webos",
        "incognito",
        "webmate",
        "bada",
        "nokia",
        "lg",
        "ucweb",
        "skyfire"
      );
      var browser = navigator.userAgent.toLowerCase();
      var isMobile = false; //记录是否移动端
      for (var i = 0; i < mobileAgent.length; i++) {
        if (browser.indexOf(mobileAgent[i]) != -1) {
          isMobile = true;
          break;
        }
      }
      return isMobile;
    }
    if (mobileskip()) {
      // console.log("222");
      // 移动端
      this.$router.push({
        path: "/videoPlayPhone",
        query:{
          id:this.videoId
        }
      });
    }
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    getVideoInfo() {
      var that = this;
      var ps = {
        video_id: that.videoId
      };
      that.$api.index.videodetail(ps).then(function(res) {
        if (res.code == 200) {
          that.videodetail = res.result;
        }
      });
    },
    toPlay(id) {
      // console.log(id);
      this.$router.push({
        path: "/videoPlay",
        query: {
          id: id
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      this.videoId = this.$route.query.id;
      this.getVideoInfo();
    }
  }
};
</script>

<style>
</style>